import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "audio-controls" }
const _hoisted_2 = { class: "audio-controls__track-info" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "  /  ", -1)
const _hoisted_5 = { class: "audio-controls__link" }
const _hoisted_6 = { key: 1 }

import { toRefs } from 'vue'
import useWidthLimitedFileName from '@/composables/UseWidthLimitedFileName'
import { defaultTrackFontSize } from '@/composables/UseWidthLimitedFileName'
import FileSelector from '@/components/common/FileSelector.vue'
import { audioAccept } from '@/static/file-types'
import VolumeControls from '@/components/preview/VolumeControls.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioControls',
  props: {
    isAudioLoading: { type: Boolean },
    trackName: null,
    showWaveform: { type: Boolean }
  },
  emits: ["fileSelected", "toggleWaveform", "resetTrim"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'fileSelected', file: File): void,
  (event: 'toggleWaveform'): void
  (event: 'resetTrim'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isAudioLoading: boolean
  trackName: string
  showWaveform: boolean
};

_useCssVars(_ctx => ({
  "5046df65": (_unref(defaultTrackFontSize))
}))



const {
  trackName
} = toRefs(props)



const truncatedTrackName = useWidthLimitedFileName(trackName)

const onFileSelected = (file: File) => {
  emits('fileSelected', file)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VolumeControls),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_unref(truncatedTrackName)), 1),
      _createElementVNode("div", null, [
        (!__props.showWaveform)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", {
                class: "audio-controls__link",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('toggleWaveform')))
              }, "Trim"),
              _hoisted_4,
              _createVNode(FileSelector, {
                accept: _unref(audioAccept),
                onFileSelected: onFileSelected
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("span", _hoisted_5, "Change", 512), [
                    [_vShow, !__props.isAudioLoading]
                  ])
                ]),
                _: 1
              }, 8, ["accept"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", {
                class: "audio-controls__link",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('resetTrim')))
              }, "Reset")
            ]))
      ])
    ])
  ]))
}
}

})